function checkRequiredFields(fields, ...objects) {
  for (let i = 0; i < objects.length; i++) {
    if (objects[i] === null) {
      return false;
      break;
    }
  }
  const merged = objects.reduce((a, b) => { return Object.assign(a, b) }, {})
  let valid = true
  for (let i = 0; i < fields.length; i++) {
    let field = fields[i];
    if (typeof field !== 'function') {
      if (!validString(merged[field])) {
        valid = false;
        break;
      }
    }
    else {
      if (!field(merged)) {
        valid = false;
        break;
      }
    }
  }
  return valid
}

export function validString(str) {
  return str !== null && str !== '' && str !== undefined
}

export function validRadio(value, expected) {
  return value === expected || value === expected.toString()
}

export function validPostalCode(str) {
  return str && !!str.replace(/[\W]/g, '').match(/^[a-zA-Z][0-9][a-zA-Z][0-9][a-zA-Z][0-9]$/)
}

export function validEmail(str) {
  return str && !!str.match(/^\S+@\S+\.\S+$/)
}

export function validUrl(str) {
  return str && !!str.match(/^((https?):\/\/)+[a-zA-Z0-9\-\.]{3,}\.[a-zA-Z]{2,}/) // Just make sure we have http and .xy
}

export function word_wrap(text, line_width, break_sequence) {
  line_width = line_width || 80
  break_sequence = break_sequence || "\n"
  return text.split("\n").map((line) => {
    return line.length > line_width ? line.replace(new RegExp(`(.{1,${line_width}})(\\s+|$)`, 'gm'), `$1${break_sequence}`).replace(/^\s+|\s+$/g, '') : line
  }).join("\n")
}

export default checkRequiredFields